module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-left"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.path === '/'),
      expression: "$route.path === '/'"
    }],
    class: {
      'menu-tabs': true, opend: _vm.opend
    },
    style: ({
      width: _vm.clientWidth + 'px'
    })
  }, [_c('div', {
    ref: "menuTabsWrap",
    staticClass: "menu-tabs-wrap"
  }, [_c('div', {
    staticClass: "menu-tabs-wrap-inner",
    style: ({
      width: _vm.len * _vm.tabWidth + _vm.extraWidth + 'px'
    })
  }, _vm._l((_vm.menuTabs), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "menu-tabs-item",
      on: {
        "click": function($event) {
          _vm.selectItem(item)
        }
      }
    }, [_c('span', {
      class: {
        active: item.active
      }
    }, [_vm._v(_vm._s(item.text))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "edit",
    on: {
      "click": _vm.toggleEditWrapper
    }
  }, [_c('span', [_vm._v("+")])]), _vm._v(" "), _c('div', {
    staticClass: "edit-wrapper"
  }, [_c('div', {
    staticClass: "edit-wrapper-inner"
  }, [_c('p', {
    staticClass: "menu-title"
  }, [_vm._v("我的栏目"), _c('span', [_vm._v("点击删除")])]), _vm._v(" "), _c('transition-group', {
    staticClass: "edit-menu-tabs-wrapper",
    on: {
      "leave": _vm.leave,
      "enter": _vm.enter
    }
  }, _vm._l((_vm.menuTabs), function(item, i) {
    return (i !== 0) ? _c('div', {
      key: item.text,
      staticClass: "edit-menu-tabs-item",
      on: {
        "click": function($event) {
          _vm.delSelectedItem(item)
        }
      }
    }, [_c('span', {
      class: {
        active: item.active
      }
    }, [_vm._v("- " + _vm._s(item.text))])]) : _vm._e()
  })), _vm._v(" "), _c('p', {
    staticClass: "menu-title"
  }, [_vm._v("推荐栏目"), _c('span', [_vm._v("点击添加")])]), _vm._v(" "), _c('transition-group', {
    staticClass: "edit-menu-tabs-wrapper",
    on: {
      "leave": _vm.leave,
      "enter": _vm.enter
    }
  }, _vm._l((_vm.otherMenuTabs), function(item, i) {
    return _c('div', {
      key: item.text,
      staticClass: "edit-menu-tabs-item",
      on: {
        "click": function($event) {
          _vm.addItemToSelected(item)
        }
      }
    }, [_c('span', [_vm._v("+ " + _vm._s(item.text))])])
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "menu-tab-mask",
    on: {
      "click": _vm.toggleEditWrapper
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4ead03e","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/loaders/theme-loader.js??ref--2-1!./src/components/MenuTabs.vue
// module id = 498
// module chunks = 7